import React, { Fragment } from "react";
import { Formik } from "formik";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";

import PageTitle from "../.././layouts/PageTitle";
import QrPass from "../../components/QRPass/QrPass";
import { audienceValidationSchema, groupaudienceValidationSchema } from "../../../utils/validationSchemas/audienceValidationSchema.js";
import { useSelector } from "react-redux";
import CustomDropdown from "../../components/Forms/CustomInputs/CustomDropdown.jsx";
import CustomMobileWithCountryCode from "../../components/Forms/CustomInputs/CustomMobileWithCountryCode.jsx";
import CustomTextarea from "../../components/Forms/CustomInputs/CustomTextarea.jsx";

const GroupFormUI = ({
    initialValues,
    handleFormSubmit,
    audienceData,
    selectedCity,
    setSelectedCity,
    setSelectedCountry,
}) => {
    const { data: cities } = useSelector((state) => state.city);
    const location = useLocation();

    // Determine the back navigation based on the current route
    const getBackNavigation = () => {
        if (location.pathname.includes('/audience/add')) {
            return "/audience"; // Go to audience listing
        } else if (location.pathname.includes('/audience/edit')) {
            return "/audience"; // Go to audience listing
        }
        return null; // Default back behavior
    };

    return (
        <Fragment>
            <PageTitle
                activeMenu="Audience"
                motherMenu="Form"
                pageContent={audienceData?._id ? "Edit Audience" : "Add Audience"}
                to={getBackNavigation()}
            />
            <Formik
                initialValues={initialValues}
                validationSchema={groupaudienceValidationSchema}
                onSubmit={handleFormSubmit}
                validateOnChange={true}
                validateOnBlur={true}
            >
                {({
                    values,
                    errors,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                    touched,
                    submitCount,
                    setFieldTouched
                }) => (
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row gap-4">
                                <div className="col-lg-9 p-2">
                                    <form onSubmit={handleSubmit}>
                                        {/* <div className=""> */}
                                        <div className="d-flex m-0">
                                            <div
                                                className="col-lg-6 p-2 position-relative card h-100"
                                                style={{ marginRight: "20px" }}
                                            >
                                                <div className="card-header p-3 border-0">
                                                    <h4 className="card-title">
                                                        {audienceData?._id ? "Edit" : "Add"} Group
                                                    </h4>
                                                </div>
                                                <div className="card-body p-2">
                                                    <div className="basic-form">
                                                        <div className="row m-0">
                                                            {/* Firstname */}
                                                            <div
                                                                className={`form-group col-sm-6 mb-1 p-2 ${(touched.firstname || submitCount > 0) && errors.firstname ? "is-invalid" : ""
                                                                    }`}
                                                            >
                                                                <label className="text-label">
                                                                    First Name*
                                                                </label>
                                                                <input
                                                                    onChange={(e) => {
                                                                        const regex = new RegExp("^[a-zA-Z0-9 ]*$");
                                                                        if (
                                                                            regex.test(e.target.value) ||
                                                                            e.target.value == ""
                                                                        )
                                                                            handleChange(e);
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                    value={values.firstname ?? ""}
                                                                    className="input form-control"
                                                                    placeholder="First name"
                                                                    name="firstname"
                                                                />
                                                                {(touched.firstname || submitCount > 0) && errors.firstname && (
                                                                    <div
                                                                        id="val-firstname-error"
                                                                        class="invalid-feedback animated fadeInUp"
                                                                        style={{ display: "block" }}
                                                                    >
                                                                        {errors.firstname}
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* Lastname */}
                                                            <div
                                                                className={`form-group col-sm-6 mb-1 p-2 ${(touched.lastname || submitCount > 0) && errors.lastname ? "is-invalid" : ""
                                                                    }`}
                                                            >
                                                                <label className="text-label">Lastname</label>
                                                                <input
                                                                    onChange={(e) => {
                                                                        const regex = new RegExp("^[a-zA-Z0-9 ]*$");
                                                                        if (
                                                                            regex.test(e.target.value) ||
                                                                            e.target.value == ""
                                                                        )
                                                                            handleChange(e);
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                    value={values.lastname}
                                                                    className="input form-control"
                                                                    placeholder="Last name"
                                                                    name="lastname"
                                                                />
                                                                {(touched.lastname || submitCount > 0) && errors.lastname && (
                                                                    <div
                                                                        id="val-lastname-error"
                                                                        class="invalid-feedback animated fadeInUp"
                                                                        style={{ display: "block" }}
                                                                    >
                                                                        {errors.lastname}
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* mobile */}

                                                            <CustomMobileWithCountryCode
                                                                fieldName="mobile"
                                                                countryCodeField="country_code"
                                                                value={values.mobile}
                                                                error={(touched.mobile || submitCount > 0) && errors.mobile ? errors.mobile : ""}
                                                                label={"Mobile"}
                                                                classes={"col-md-12 p-2"}
                                                                // handleBlur={handleBlur}
                                                                handleBlur={() => {
                                                                    setFieldTouched("mobile", true, true);
                                                                }}
                                                                setSelectedCountry={setSelectedCountry}
                                                                inputType={"text"}
                                                                setFieldValue={setFieldValue}
                                                                country_code={initialValues?.country_code}
                                                                disabled={!!audienceData?._id}
                                                                handleChange={(e) => {
                                                                    if (e.target.value == "") {
                                                                        setFieldValue("mobile", "");
                                                                    } else {
                                                                        if (/[0-9]/.test(e.target.value))
                                                                            setFieldValue("mobile", e.target.value);
                                                                    }
                                                                }}
                                                            // maxLength={15}
                                                            // minLength={10}
                                                            />

                                                            {/* Email */}
                                                            <div
                                                                className={`form-group col-md-12 mb-1 p-2 ${(touched.email || submitCount > 0) && errors.email ? "is-invalid" : ""
                                                                    }`}
                                                            >
                                                                <label className="text-label">Email</label>
                                                                <input
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.email}
                                                                    className="input form-control"
                                                                    type="email"
                                                                    name="email"
                                                                    placeholder="you@example.com"
                                                                />
                                                                {(touched.email || submitCount > 0) && errors.email && (
                                                                    <div
                                                                        id="val-email-error"
                                                                        class="invalid-feedback animated fadeInUp"
                                                                        style={{ display: "block" }}
                                                                    >
                                                                        {errors.email}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            {/* Gender Dropdown */}
                                                            <div
                                                                className={`form-group col-md-12 mb-1 p-2 ${(touched.gender || submitCount > 0) && errors.gender ? "is-invalid" : ""
                                                                    }`}
                                                            >
                                                                <label className="text-label">Gender</label>
                                                                <select
                                                                    onChange={(e) => {
                                                                        // Normalize to lowercase for storage
                                                                        setFieldValue('gender', e.target.value.toLowerCase());
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                    value={values.gender ? values.gender.toLowerCase() : ""}
                                                                    className="input form-select form-control"
                                                                    name="gender"
                                                                    style={{
                                                                        minHeight: "41px",
                                                                    }}
                                                                >
                                                                    <option value="">Select gender</option>
                                                                    <option value="male">Male</option>
                                                                    <option value="female">Female</option>
                                                                    <option value="prefer not to share">
                                                                        Prefer Not to Share
                                                                    </option>
                                                                </select>
                                                                {(touched.gender || submitCount > 0) && errors.gender && (
                                                                    <div
                                                                        id="val-firstname-error"
                                                                        class="invalid-feedback animated fadeInUp"
                                                                        style={{ display: "block" }}
                                                                    >
                                                                        {errors.gender}
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* City Dropdown */}
                                                            {/* <CustomDropdown
                                                                fieldName="city"
                                                                values={selectedCity}
                                                                error={errors.city}
                                                                label={"City"}
                                                                classes={"col-md-12 p-0"}
                                                                setFieldValue={setFieldValue}
                                                                handleChange={(value) => setSelectedCity(value)}
                                                                options={
                                                                cities
                                                                    ? cities?.map((data) => {
                                                                        return {
                                                                        label: data.name,
                                                                        value: data._id,
                                                                        };
                                                                    })
                                                                    : []
                                                                }
                                                            /> */}

                                                            {/* City Dropdown */}
                                                            <div
                                                                className={`form-group col-md-12 mb-1 p-2 ${(touched.city || submitCount > 0) && errors.city ? "is-invalid" : ""
                                                                    }`}
                                                            >
                                                                <label className="text-label">City</label>
                                                                <select
                                                                    name="city"
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        const selected = cities?.find(
                                                                            (c) => c._id === e.target.value
                                                                        );
                                                                        setSelectedCity(
                                                                            selected
                                                                                ? {
                                                                                    label: selected.name,
                                                                                    value: selected._id,
                                                                                }
                                                                                : null
                                                                        );
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                    value={values.city}
                                                                    className="input form-select form-control"
                                                                    style={{ minHeight: "41px" }}
                                                                >
                                                                    <option value="">Select City</option>
                                                                    {cities?.map((city) => (
                                                                        <option key={city._id} value={city._id}>
                                                                            {city.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                {(touched.city || submitCount > 0) && errors.city && (
                                                                    <div
                                                                        className="invalid-feedback animated fadeInUp"
                                                                        style={{ display: "block" }}
                                                                    >
                                                                        {errors.city}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div
                                                                className={`form-group col-md-12 mb-1 p-2 ${(touched.hear_about || submitCount > 0) && errors.hear_about ? "is-invalid" : ""
                                                                    }`}
                                                            >
                                                                <label className="text-label">Where did you hear about us?</label>
                                                                <select
                                                                    name="hear_about"
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                    value={values.hear_about}
                                                                    className="input form-select form-control"
                                                                    style={{ minHeight: "41px" }}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="admin">Admin</option>
                                                                    {/* <option value="Social Media">Social Media</option>
                                                                    <option value="Hoardings">Hoardings</option>
                                                                    <option value="Friends & Family">Friends & Family</option>
                                                                    <option value="Past Participants">Past Participants</option>
                                                                    <option value="Artists">Artists</option> */}
                                                                    <option value="College group">College group</option>
                                                                    <option value="Friends & Family">Friends & Family</option>
                                                                    <option value="Instagram/Facebook">Instagram/Facebook</option>
                                                                    <option value="Instagram/Facebook Ad">Instagram/Facebook Ad</option>
                                                                    <option value="Newspaper Ad">Newspaper Ad</option>
                                                                    <option value="Radio">Radio</option>
                                                                    <option value="WhatsApp">WhatsApp</option>
                                                                </select>
                                                                {(touched.hear_about || submitCount > 0) && errors.hear_about && (
                                                                    <div
                                                                        className="invalid-feedback animated fadeInUp"
                                                                        style={{ display: "block" }}
                                                                    >
                                                                        {errors.hear_about}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 p-2 card h-100">
                                                <div className="card-header p-3 border-0">
                                                    <h4 className="card-title">
                                                        {audienceData?._id
                                                            ? `Update Organization info`
                                                            : "Add Organization info"}
                                                    </h4>
                                                </div>
                                                <div className="card-body p-2">
                                                    <div className="basic-form">
                                                        <div className="row m-0">
                                                            <div
                                                                className={`form-group col-md-6 mb-3 ${(touched.organization_name || submitCount > 0) && errors.organization_name ? "is-invalid" : ""
                                                                    }`}
                                                            >
                                                                <label className="text-label">
                                                                    Organization Name
                                                                </label>
                                                                <input
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.organization_name}
                                                                    className="input form-control"
                                                                    name="organization_name"
                                                                    type="text"
                                                                />
                                                                {(touched.organization_name || submitCount > 0) && errors.organization_name && (
                                                                    <div
                                                                        id="val-organization_name-error"
                                                                        class="invalid-feedback animated fadeInUp"
                                                                        style={{ display: "block" }}
                                                                    >
                                                                        {errors.organization_name}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div
                                                                className={`form-group col-md-6 mb-3 ${(touched.no_of_group_guest || submitCount > 0) && errors.no_of_group_guest ? "is-invalid" : ""
                                                                    }`}
                                                            >
                                                                <label className="text-label">
                                                                    Number of People
                                                                </label>
                                                                <input
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.no_of_group_guest}
                                                                    className="input form-control"
                                                                    name="no_of_group_guest"
                                                                    type="number"
                                                                    min="1"
                                                                />
                                                                {(touched.no_of_group_guest || submitCount > 0) && errors.no_of_group_guest && (
                                                                    <div
                                                                        id="val-no_of_group_guest-error"
                                                                        class="invalid-feedback animated fadeInUp"
                                                                        style={{ display: "block" }}
                                                                    >
                                                                        {errors.no_of_group_guest}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <CustomTextarea
                                                                errors={errors}
                                                                setFieldValue={setFieldValue}
                                                                handleBlur={handleBlur}
                                                                values={values}
                                                                touched={touched}
                                                                submitCount={submitCount}
                                                            />
                                                        </div>

                                                        <button
                                                            type="submit"
                                                            className="btn btn-primary float-end d-flex align-items-center"
                                                            style={{
                                                                marginRight: "0 !important",
                                                                marginTop: "1.7rem",
                                                            }}
                                                            disabled={isSubmitting}
                                                        >
                                                            {isSubmitting ? (
                                                                <>
                                                                    <Spinner
                                                                        as="span"
                                                                        animation="border"
                                                                        size="sm"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                        className="me-2"
                                                                    />
                                                                    <span>
                                                                        {audienceData?._id
                                                                            ? "Updating..."
                                                                            : "Generating..."}
                                                                    </span>
                                                                </>
                                                            ) : (
                                                                <span>
                                                                    {audienceData?._id
                                                                        ? "Update QR Pass"
                                                                        : "Generate QR Pass"}
                                                                </span>
                                                            )}
                                                        </button>
                                                        {/* <button className="btn btn-danger light">Cancel</button> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* </div> */}
                                    </form>
                                </div>
                                <div className="col-lg-2 p-2">
                                    {audienceData?.qr ? (
                                        <QrPass
                                            memberCount={audienceData?.no_of_group_guest ?? 0}
                                            name={audienceData.firstname}
                                            fullName={`${audienceData.firstname} ${audienceData.lastname}`}
                                            ticketId={audienceData?.qrcode ?? "C1234"}
                                            // btnTxt={"Send QR to Whatsapp"}
                                            btnTxt={"Download QR Pass"}
                                            audienceData={audienceData}
                                            qr={audienceData?.qr}
                                        />
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Formik>
        </Fragment>
    );
};

export default GroupFormUI;
